<template>
	<StepTemplate
		title="Booking Confirmation"
		hideNavigation
		:restricted-height="true"
		:isLoading="isLoading"
		:nextNavigation="{ hidden: true }"
		:prevNavigation="{ hidden: true }"
	>
		<transition name="fade">
			<p v-if="!isLoading" class="confirmation type--serif">Thanks for your enquiry. We’ll finalise all the details and send you an email with confirmation of your flight time, aircraft and extras.</p>
		</transition>
	</StepTemplate>

</template>

<script>
import StepTemplate from "./StepTemplate"
import { mapGetters } from "vuex"

export default {
	name: "FlytConfirmationStep",

	components: {StepTemplate},

	computed: {
		...mapGetters("bookingForm", [
			"loadingStep",
		]),

		isLoading() {
			return this.loadingStep === 4
		}
	}
}
</script>

<style lang="scss" scoped>
.confirmation {
	color: $colour-teal;
}
</style>